.container {
  border-bottom: 2px solid;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  padding: 0 var(--dds-spacing-x1);
}

.container--info {
  border-color: var(--dds-color-border-info);
  background-color: var(--dds-color-surface-info-default);

  .icon {
    color: var(--dds-color-icon-on-info-default);
  }
}

.container--danger {
  border-color: var(--dds-color-border-danger);
  background-color: var(--dds-color-surface-danger-default);

  .icon {
    color: var(--dds-color-icon-on-danger-default);
  }
}

.container--warning {
  border-color: var(--dds-color-border-warning);
  background-color: var(--dds-color-surface-warning-default);

  .icon {
    color: var(--dds-color-icon-on-warning-default);
  }
}

.content {
  display: flex;
  align-items: center;
  padding: var(--dds-spacing-x0-75) var(--dds-spacing-x1-5)
    var(--dds-spacing-x0-75) 0;
}

.content--closable {
  padding-right: var(--dds-spacing-x0-75);
}

.icon {
  margin-right: var(--dds-spacing-x0-75);
}
